import { Icon, useTheme } from '@pinwheel/origami';
import React from 'react';
import './screens/Intro.scss';
import { useAppLogo } from './theme';
var WorkspaceIcon = function (_a) {
    var src = _a.src;
    return (React.createElement("div", { className: "introLogo" },
        React.createElement("img", { src: src, alt: "welcome" })));
};
var IntroLogo = function () {
    var resolveColor = useTheme().resolveColor;
    var appLogo = useAppLogo();
    return (React.createElement("div", { className: "introLogos" },
        appLogo && React.createElement(WorkspaceIcon, { src: appLogo.src }),
        !appLogo || !appLogo.hidePinwheel ? (React.createElement("div", { className: "introLogo", style: {
                backgroundColor: resolveColor({
                    type: 'theme',
                    colorLegacy: 'Neutral/0',
                    colorNext: 'background/alt',
                }),
            } },
            React.createElement(Icon, { icon: "pinwheelLogo", size: 25, color: {
                    type: 'pinwheel',
                } }))) : null));
};
export default IntroLogo;
